module.exports = __webpack_public_path__ + "static/media/Y_N_X.7d267ad9.png";